<template>
    <div class="main-block request-management">
        <div class="div col-12 p-0 d-flex align-items-start">
            <h4 class="">{{ $t('title.ZohoAccounts') }}</h4>
        </div>
        <div class="scrollable-block">
            <div class="col-12 row mt-3 m-0 p-0" style="min-height: 90%">
                <crud-table :columns="columns" :list-url="listUrl" ref="application-table" v-on:refresh="resetFilter">
                    <template slot>
                        <b-button variant="primary" @click="$router.go(-1)">
                            <b-icon icon="arrow-left" class="icon-style"></b-icon>
                        </b-button>



                    </template>




                    <!-- Display Response Payload -->
                    <template #cell(response_payload)="{ item }">
                        <div>
                            <div v-for="(value, key) in item.response_payload" :key="key"
                                class="d-flex justify-content-between align-items-center">
                                <span>
                                    <strong>{{ key }}</strong> :-{{ value }}
                                </span>
                            </div>
                        </div>
                    </template>


                    <!-- Display Created At Time -->
                    <template #cell(created_at)="{ item }">
                        <div>
                            <span>
                                {{ formatDate(item.created_at) }}
                            </span>
                        </div>
                    </template>
                </crud-table>

            </div>
        </div>
    </div>
</template>

<script>
import { request } from "@/Util/Request";
import { Modal } from "bootstrap";

const FILTER_FORM = {
    roles: null,
    statuses: null,
    integration_id: null // Adding the new filter for integration_id
};
const COLUMN_STATE = (self) => [
    { key: 'integration_id', label: self.$t('title.integration_id'), sortable: true },
    { key: 'crm_account_id', label: self.$t('title.crm_account_id'), sortable: true },
    { key: 'account_name', label: self.$t('title.account_name'), sortable: true },
    { key: 'account_number', label: self.$t('title.account_number'), sortable: true },
    { key: 'account_type', label: self.$t('title.account_type'), sortable: true },
    { key: 'industry', label: self.$t('title.industry'), sortable: true },
    { key: 'annual_revenue', label: self.$t('title.annual_revenue'), sortable: true },
    { key: 'ownership', label: self.$t('title.ownership'), sortable: true },
    { key: 'employees', label: self.$t('title.employees'), sortable: true },
    { key: 'website', label: self.$t('title.website'), sortable: true },
    { key: 'phone', label: self.$t('title.phone'), sortable: true },
    { key: 'fax', label: self.$t('title.fax'), sortable: true },
    { key: 'billing_street', label: self.$t('title.billing_address'), sortable: true },
    { key: 'shipping_street', label: self.$t('title.shipping_address'), sortable: true },
    { key: 'description', label: self.$t('title.description'), sortable: true },
    { key: 'status', label: self.$t('title.status'), sortable: true }
];



export default {
    data() {
        return {
            selectedUsers: [], // Store selected Microsoft User IDs
            filters: { ...FILTER_FORM },
        };
    },
    mounted() {
        if(this.$route.query.id) {
            this.$refs['application-table'].handleCustomSearch(this.$route.query.id);
        }
    },
    methods: {
        resetFilter() {
            this.filters = { ...FILTER_FORM };
            this.$refs['application-table'].handleFilter({ filters: this.filters });
        },
        formatDate(dateString) {
            return new Date(dateString).toLocaleString();
        },
    },
    computed: {
        listUrl() {
            return `admin/zoho/crm/accounts/${this.$route.params.id || ''}`;
        },
        columns() {
            return COLUMN_STATE(this);
        }
    }
};
</script>
